<template>
  <div class="filter-overview">
    <div class="search-input">
      <label for="approval-search"
        >{{ i18n.t('/ManagerApproval/Filter/Search') || 'Zoeken' }}:</label
      >
      <input
        id="approval-search"
        v-model="searchText"
        type="text"
        :placeholder="
          i18n.t('/ManagerApproval/Filter/SearchPlaceholder') || 'Zoek op klant, configuratie...'
        "
        @input="onSearchChange"
      />
    </div>

    <div class="salesperson-filter">
      <label for="salesperson-filter"
        >{{ i18n.t('/ManagerApproval/Filter/Salesperson') || 'Verkoper' }}:</label
      >
      <input
        id="salesperson-filter"
        v-model="searchPonId"
        type="text"
        :placeholder="
          i18n.t('/ManagerApproval/Filter/SalespersonPlaceholder') || 'Filter op verkoper...'
        "
        @input="onPonIdChange"
      />
    </div>

    <div class="filter-actions">
      <app-button type="button" button-type="secondary" @click="clearFilters">
        {{ i18n.t('/ManagerApproval/Filter/Clear') || 'Wissen' }}
      </app-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'

export default {
  name: 'ManagerApprovalFilter',
  components: {
    AppButton,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      searchText: '',
      searchPonId: '',
      searchTimeout: null,
    }
  },
  methods: {
    ...mapActions('managerApproval', ['updateFilters']),
    onSearchChange() {
      // Debounce search input
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.updateFilters({ searchText: this.searchText })
        this.$emit('update')
      }, 500)
    },
    onPonIdChange() {
      // Debounce PON ID input
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.updateFilters({ searchPonId: this.searchPonId })
        this.$emit('update')
      }, 500)
    },
    clearFilters() {
      this.searchText = ''
      this.searchPonId = ''
      this.updateFilters({ searchText: '', searchPonId: '' })
      this.$emit('update')
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-overview {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  column-gap: 1em;
  align-items: end;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.search-input,
.salesperson-filter {
  display: flex;
  flex-direction: column;
}

label {
  font-weight: 600;
  margin-bottom: 0.25rem;
  color: #333;
}

input {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
}

input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.filter-actions {
  display: flex;
  align-items: center;
}
</style>
